import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PublicFooter from "../components/PublicFooter";
import api from "../lib/api";

const fmtDate = (v) => {
    if (!v) return null;
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" });
};

/**
 * LegalPlaceholder — página pública de /termos e /privacidade. Carrega o
 * conteúdo publicado pelo Super Admin (endpoint varia por página); se ainda
 * não há nada cadastrado, cai no estado "Em breve" de sempre.
 */
const LegalPlaceholder = ({ title, endpoint }) => {
    const [doc, setDoc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let alive = true;
        setLoading(true);
        api.get(endpoint)
            .then((d) => { if (alive) setDoc(d); })
            .catch(() => { if (alive) setDoc(null); })
            .finally(() => { if (alive) setLoading(false); });
        return () => { alive = false; };
    }, [endpoint]);

    const hasContent = Boolean(doc && doc.content && doc.content.trim().length > 0);
    const updatedLabel = fmtDate(doc?.updated_at);

    return (
        <div className="min-h-screen w-full bg-slate-950 text-white flex flex-col" data-testid="legal-placeholder-page">
            <header className="px-6 lg:px-12 pt-6 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3">
                    <div className="h-12 w-12 flex items-center justify-center shrink-0">
                        <img src="/brand/kinng-mark-transparent.png" alt="Kinng.app" className="h-full w-full object-contain" />
                    </div>
                    <div>
                        <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500">
                            Plataforma SaaS
                        </div>
                        <div className="salon-heading text-lg leading-none">Kinng.app</div>
                    </div>
                </Link>
                <Link
                    to="/"
                    data-testid="legal-back-link"
                    className="min-h-[44px] flex items-center px-4 rounded-full border border-white/10 hover:border-amber-500/40 text-slate-400 hover:text-amber-200 text-xs uppercase tracking-wider transition-all"
                >
                    <i className="fa-solid fa-arrow-left mr-2"></i>Voltar
                </Link>
            </header>

            {loading ? (
                <main className="flex-1 flex items-center justify-center px-6 py-16">
                    <div className="text-slate-500 text-sm">Carregando…</div>
                </main>
            ) : hasContent ? (
                <main className="flex-1 px-6 py-12 lg:py-16" data-testid="legal-content">
                    <div className="max-w-3xl mx-auto w-full">
                        <div className="h-14 w-14 rounded-2xl bg-amber-500/10 border border-amber-500/25 text-amber-300 flex items-center justify-center mb-6">
                            <i className="fa-solid fa-file-lines text-xl"></i>
                        </div>
                        <h1 className="salon-heading text-3xl sm:text-4xl text-white mb-2">{title}</h1>
                        {updatedLabel && (
                            <p className="text-[11px] uppercase tracking-wider text-slate-500 mb-8">
                                Versão {doc.version} · Atualizado em {updatedLabel}
                            </p>
                        )}
                        <div className="text-slate-300 text-sm leading-relaxed whitespace-pre-wrap">
                            {doc.content}
                        </div>
                    </div>
                </main>
            ) : (
                <main className="flex-1 flex items-center justify-center px-6 py-16">
                    <div className="max-w-lg text-center">
                        <div className="h-16 w-16 rounded-2xl bg-amber-500/10 border border-amber-500/25 text-amber-300 flex items-center justify-center mx-auto mb-6">
                            <i className="fa-solid fa-file-lines text-2xl"></i>
                        </div>
                        <h1 className="salon-heading text-3xl sm:text-4xl text-white mb-3">{title}</h1>
                        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-amber-500/30 bg-amber-500/5 text-amber-300 text-[10px] uppercase tracking-[0.25em] font-bold mb-5">
                            Em breve
                        </div>
                        <p className="text-slate-400 text-sm leading-relaxed">
                            Esta página está sendo preparada pela nossa equipe e será publicada em breve.
                            Em caso de dúvidas, entre em contato pelo{" "}
                            <a href="mailto:suporte@kinng.app" className="text-amber-300 hover:underline">
                                suporte@kinng.app
                            </a>.
                        </p>
                    </div>
                </main>
            )}

            <PublicFooter />
        </div>
    );
};

export default LegalPlaceholder;
